import 'isomorphic-fetch';

import requestTimeout from './request-timeout';
import Request from './request';
import * as Sentry from '@sentry/browser';
import Cookies from 'js-cookie';
const abortController = new AbortController();
const { signal } = abortController;
import moLogin, { toggleLogin } from '@store/login';

const apiPut = (requestURL: string, body: object, second: number = 200000) => {
  return Promise.race([
    requestTimeout(second),
    Request('put', requestURL, signal, body),
  ]).then((response): Promise<null> => {
    // 返回格式 response.json(), .text(), .blob(), .formData(), .arrayBuffer()
    // @ts-ignore
    if (response.status === 200 || response.code === 0) return response.json();
    // if (response.code === 0) return response.json();
    // @ts-ignore
    // throw response.json();
    return response.json();

    // 接口请求超时，中断请求
    // abortController.abort();
    // throw 'timeout';
  }).then((data: any) => {
    if (data.code !== 0) {
      if (data.code === 5) {
        console.log('后台错误');
        // changeErrorTyppe();
        Sentry.captureException(data.msg);
      }
      if (data.code === -5) {
        console.log('请登录');
        Cookies.remove('access_token');
      }
      if (data.code === 2) {
        // changeErrorTyppe();
        console.log('后台逻辑错误');
        Sentry.captureException(data.msg);
      }
      if (data.code.toString()[0] === '4') {
        Cookies.remove('access_token');
        // localforage.clear().then(() => {});
        toggleLogin(true);
      }
    }
    return data;
  }).catch(err => {
    // 错误处理
    // @ts-ignore
    // err.then(error => {
    //   console.log('Something wrong -- ', error);
    // });
    return null;
  }).finally(() => {
    // Maybe do something
    // console.log('--- done --- ');
  });
};

export default apiPut;
